export default {
  title: 'ROAS por Canal',
  xAxisName: 'Canal',
  mean: 'Média',
  lower: 'Inferior',
  upper: 'Superior',
  crossUnitWarning: 'Cada barra é o {kpi} que o modelo atribui ao canal dividido pelo que foi gasto nele, e os dois são medidos em unidades diferentes. Por isso o eixo y não está em "vezes o investido", e sim em {unit}: o {kpi} que cada unidade de gasto trouxe. Os canais continuam comparáveis entre si e o intervalo de confiança continua válido; o que não se aplica é compará-los com o ROAS de um modelo em que {kpi} e gasto compartilham a unidade.',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
